import * as React from "react";

import Card from "@material-ui/core/Card";
import Divider from "@material-ui/core/Divider";

// perfect scrollbar
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import CardHeader from "../../../components/CardHeader";
import Table from "../../../components/Table";
import useDeepMemo from "../../../hooks/useDeepMemo";
import { OState } from "../../../utils/types";
import { getColumnsSizeBreakup, getRowsSizeBreakup } from "../cutPlanHelper";
import { getCutOrderFlowInfoList } from "../../../helpers/orderHelper";

const SizeBreakup = props => {
  const { order, cutOrder } = props;

  const flowInfoList = useDeepMemo(() => getCutOrderFlowInfoList(order, cutOrder), [order, cutOrder]);

  //** Prepare Size Breakup Columns for View mode **/
  const { columns, headerRows } = useDeepMemo(() => getColumnsSizeBreakup(cutOrder, order), [order, cutOrder]);

  //** Prepare Size Breakup Rows for View mode **/
  const rows = useDeepMemo(() => getRowsSizeBreakup(flowInfoList, order), [flowInfoList, order]);

  if (cutOrder?.stateValue > OState.MAIN_CUTPLAN_GENERATED.stateValue) {
    return <div />;
  }

  return (
    <Card>
      <CardHeader title="Size Breakup" />
      <Divider />
      <PerfectScrollbar>
        <Table
          columns={columns}
          headerRows={headerRows}
          rows={rows}
          headerCellStyle={column => ({
            borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
            borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
            backgroundColor: "#C6D0DA"
          })}
          cellStyle={({ column, record }) =>
            record.name === "Total"
              ? {
                  fontWeight: "bold",
                  borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                  borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                }
              : {
                  borderLeft: column.leftBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined,
                  borderRight: column.rightBorder ? "1px solid rgba(224, 224, 224, 1)" : undefined
                }
          }
        />
      </PerfectScrollbar>
    </Card>
  );
};

export default SizeBreakup;
